<template>
   <div class="ui-icon" :style="iconStyle" v-html="svgContent"></div>
</template>

<script>
export default {
   name: "Icon",
   props: {
      name: {
         type: String,
         required: true,
      },
      color: {
         type: String,
         default: null,
      },
   },
   computed: {
      iconStyle() {
         return this.color ? { '--icon-color': this.color } : {};
      },
   },
   data() {
      return {
         svgContent: "",
      };
   },
   mounted() {
      this.loadSvg();
   },
   watch: {
      name() {
         this.loadSvg();
      },
   },
   methods: {
      async loadSvg() {
         try {
            const svgModule = await import(`@/assets/icons/${this.name}.svg`);
            const svgUrl = svgModule.default;
            const response = await fetch(svgUrl);
            this.svgContent = await response.text();
         } catch (error) {
            console.error(`Icon "${this.name}" yüklenemedi:`, error);
            this.svgContent = "";
         }
      },
   },
};
</script>

<style scoped>
.ui-icon {
   display: inline-flex;
   align-items: center;
   justify-content: center;
}

.ui-icon >>> svg {
   width: 100%;
   height: 100%;
   max-width: 24px;
   max-height: 24px;
}

.ui-icon >>> svg path,
.ui-icon >>> svg circle,
.ui-icon >>> svg rect,
.ui-icon >>> svg line,
.ui-icon >>> svg polyline,
.ui-icon >>> svg polygon {
   stroke: var(--icon-color, var(--gray-900));
}
</style>
